export default "__VITE_ASSET__xxpJoRxa__"